
import orm from './orm';
import { createReducer } from 'redux-orm';
export const reducer = createReducer(orm);
export { default as orm } from './orm';
export { default as dbStateSelector } from './db-state-selector';